import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";
import { printDate, printLocation } from "../../../utils/helper";
import React, { useState, useEffect } from "react";
import {
  user as userAPI,
  notificationGroup as notificationGroupAPI,
  team,
} from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { useQuery } from "@tanstack/react-query";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import NormalInput from "../../../components/form/HorizontalNormalInput";

import ConfirmationDlg from "../../../components/ConfirmationDlg";
import Select, { StylesConfig } from "react-select";
import { Form } from "react-bootstrap";
import NormalSelect from "../../../components/form/HorizontalNormalSelect";
import LoadingIndicator from "../../../components/LoadingIndicator";
import { useNavigate } from "react-router-dom";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "#0000007a",
    zIndex: 999999,
  }),
  input: (styles) => ({
    ...styles,
    color: "white",
    zIndex: 999999,
  }),
  menu: (styles) => ({
    ...styles,
    color: "grey",
    zIndex: 99999999999999999,
    opacity: 1,
  }),
};

const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const defaultNotificationSelecttions = [
  {
    name: "high_vibration_alert",
    active: false,
    email: false,
    whatsapp: false,
    frequency: {
      total: 1,
      type: "day",
      sent_at: [],
    },
    sequential: "",
  },
  {
    name: "high_temperature_alert",
    active: false,
    email: false,
    whatsapp: false,
    frequency: {
      total: 1,
      type: "day",
      sent_at: [],
    },
    sequential: "",
  },
  {
    name: "alarm_reminder",
    active: false,
    email: false,
    whatsapp: false,
    frequency: {
      total: 1,
      type: "day",
      sent_at: [],
    },
    sequential: "",
  },
  {
    name: "urgent_alarm",
    active: false,
    email: false,
    whatsapp: false,
    frequency: {
      total: 1,
      type: "day",
      sent_at: [],
    },
    sequential: "",
  },
  {
    name: "offline_alert",
    active: false,
    email: false,
    whatsapp: false,
    frequency: {
      total: 1,
      type: "day",
      sent_at: [],
    },
    sequential: "",
  },
];

const notificationType = [
  {
    name: "Alarm notification",
    value: "urgent_alarm",
  },
  {
    name: "High vibration notification",
    value: "high_vibration_alert",
  },
  {
    name: "Alarm reminder",
    value: "alarm_reminder",
  },
  {
    name: "Offline sensor",
    value: "offline_alert",
  },
  {
    name: "High temperature notification",
    value: "high_temperature_alert",
  },
];

function NotificationHierarchyConfiguration() {
  const defaultNotificationGroup = {
    team_id: "",
    email: false,
    whatsapp: false,
    frequency: {
      total: 1,
      type: "day",
      sent_at: [],
    },
    time_range: {
      start: "06:00",
      end: "09:00",
    },
    escalations: [],
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [datas, setDatas] = useState([]);
  const [teams, setTeams] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [notificationGroup, setNotificationGroup] = useState([
    { ...defaultNotificationGroup },
  ]);

  const navigate = useNavigate();

  const handleChangeTeam = (e, index) => {
    setNotificationGroup(
      notificationGroup.map((group, i) =>
        i === index ? { ...group, team_id: e.target.value } : group
      )
    );
  };

  const handleChangeFrequency = (e, index) => {
    const key = e.target.name;
    const value = e.target.value;
    const copy = [...notificationGroup];
    copy[index].frequency[key] = value;
    if (key == "type") copy[index].frequency.sent_at = [];
    setNotificationGroup(copy);
  };

  const handleChangeSentAt = (e, index) => {
    const value = e;
    const copy = [...notificationGroup];
    copy[index].frequency.sent_at = value;
    setNotificationGroup(copy);
  };

  const handleChangeTimeRange = (e, index) => {
    const value = e.target.value;
    const copy = [...notificationGroup];
    copy[index].time_range[e.target.name] = value;
    setNotificationGroup(copy);
  };

  const handleDeleteGroup = (index) => {
    setNotificationGroup(notificationGroup.filter((_, i) => i !== index));
  };

  const handleAddMoreGroup = () => {
    setNotificationGroup([
      ...notificationGroup,
      { ...defaultNotificationGroup },
    ]);
  };

  const handleChangeEscalationTeam = (e, index, escalationIndex) => {
    const value = e.target.value;
    const copy = [...notificationGroup];
    copy[index].escalations[escalationIndex].team_id = value;
    setNotificationGroup(copy);
  };

  const handleChangeEscalation = (e, index, escalationIndex) => {
    const value = e.target.value;
    const copy = [...notificationGroup];
    copy[index].escalations[escalationIndex].escalation_time = value;
    setNotificationGroup(copy);
  };

  const handleDeleteEscalation = (index, escalationIndex) => {
    const copy = [...notificationGroup];
    copy[index].escalations.splice(escalationIndex, 1);
    setNotificationGroup(copy);
  };

  const handleAddMoreEscalation = (index) => {
    const copy = [...notificationGroup];
    copy[index].escalations.push({ team_id: "", escalation_time: 1 });
    setNotificationGroup(copy);
  };

  const handleEditNotification = async (notification) => {
    setIsLoading(true);
    await getTeams();
    await getNotificationGroupByType(notification.value);

    setSelectedNotification(notification);
    setIsModalOpen(true);

    setIsLoading(false);
  };

  const getTeams = async () => {
    const res = await team.list({});
    if (res.ok) {
      const body = await res.json();
      let data = body.data;
      data.map((d) => {
        d["name"] = d.team_name;
        d["value"] = d.id;
      });
      setTeams(data);
    }
  };

  const getNotificationGroupByType = async (type) => {
    const res = await notificationGroupAPI.getOne({ type });
    if (res.ok) {
      const body = await res.json();
      if (body.data) {
        const configurations = body.data.configurations;

        setNotificationGroup(configurations);
      } else {
        console.log("no data");
        console.log(defaultNotificationGroup);
        setNotificationGroup([{ ...defaultNotificationGroup }]);
      }
    }
  };

  const getAllNotificationGroup = async () => {
    const res = await notificationGroupAPI.getOne({});
    if (res.ok) {
      const body = await res.json();
      setDatas(body.data);
    }
  };

  const handleSubmit = async () => {
    // Validate time ranges before submitting
    for (let i = 0; i < notificationGroup.length; i++) {
      const group = notificationGroup[i];

      if (group.time_range && group.time_range.start && group.time_range.end) {
        const startTime = new Date(`2000-01-01T${group.time_range.start}`);
        const endTime = new Date(`2000-01-01T${group.time_range.end}`);

        if (startTime >= endTime) {
          toast.error(`Group ${i + 1}: Start time must be before end time`);
          return; // Stop submission if validation fails
        }
      }
    }

    setIsLoading(true);
    const payload = {
      type: selectedNotification.value,
      configurations: notificationGroup,
    };

    const response = await notificationGroupAPI.create(payload);
    if (response.ok) {
      const body = await response.json();
      if (body.success) {
        toast.success("Notification hierarchy is successfully updated");
        getAllNotificationGroup();
      }
    } else {
      toast.error("Failed to add notification hierarchy");
    }
    setIsLoading(false);
  };

  const handleChangePlatform = (e, index, platform) => {
    const copy = notificationGroup.map((e) => e);
    copy[index][platform] = e.target.checked;
    setNotificationGroup(copy);
  };

  const getTotalNotificationGroup = (type) => {
    const group = datas.find((data) => data.type == type);
    if (group && group.configurations && Array.isArray(group.configurations)) {
      return group.configurations.length;
    }
    return 0;
  };

  useEffect(() => {
    getTeams();
    getAllNotificationGroup();
  }, []);

  const columns = [
    {
      name: "Type",
      selector: (row) => row.name,
    },
    {
      name: "Number of Notification Groups",
      center: true,
      selector: (row) => row.value,
      cell: (row) => <span>{getTotalNotificationGroup(row.value)}</span>,
    },
    {
      name: "Create New Notification Group",
      selector: (row) => row.name,
      center: true,
      cell: (row) => (
        <div>
          <button
            onClick={() => {
              handleEditNotification(row);
            }}
            className="btn btn-sm btn-outline-theme mx-1"
          >
            <i className="fa fa-edit"></i>
          </button>
        </div>
      ),
    },
  ];

  const ExpandedComponent = (row) => {
    const groups = datas.find((data) => data.type == row.data.value);
    if (!groups)
      return <div className="p-10 mt-4">No Notification Group Found</div>;

    return (
      <div style={{ padding: "10px" }}>
        {groups &&
          groups.configurations &&
          groups.configurations.map((group, index) => (
            <Card key={index} className="mb-3">
              <CardHeader className="d-flex">
                <h5>Notification Group {index + 1}</h5>
              </CardHeader>
              <CardBody>
                <div className="row my-2">
                  <div className="col-md-3">
                    <Form.Check
                      style={{ textTransform: "capitalize" }}
                      type={"checkbox"}
                      label={"Email"}
                      checked={group.email}
                    />
                  </div>

                  <div className="col-md-3">
                    <Form.Check
                      style={{ textTransform: "capitalize" }}
                      type={"checkbox"}
                      label={"WhatsApp"}
                      checked={group.whatsapp}
                    />
                  </div>
                </div>

                <hr />

                <div className="mt-2">
                  <label className="form-label">Group</label>
                  <input
                    className="form-control"
                    style={{ cursor: "pointer" }}
                    value={
                      teams.find((team) => team.value == group.team_id)?.name
                    }
                    onClick={() => navigate(`/configuration/teams`)}
                  />
                </div>

                <div className="row align-items-center mt-2">
                  <div className="col-md-5">
                    <label className="form-label">
                      Total Notification per day
                    </label>
                    <input
                      disabled
                      type="number"
                      name="total"
                      min={1}
                      className="form-control"
                      value={group.frequency.total}
                    />
                  </div>

                  <div className="col-md-3 ">
                    <label className="form-label">Type</label>
                    <input
                      className="form-control capitalize"
                      disabled
                      value={group.frequency.type}
                    />
                  </div>

                  {group.frequency.type == "week" && (
                    <div className="col-md-12 mt-2">
                      <label className="form-label">Selected Days</label>
                      <input
                        className="form-control"
                        disabled
                        value={group.frequency.sent_at
                          .map((d) => d.label)
                          .join(", ")}
                      />
                    </div>
                  )}

                  {group.frequency.type == "month" && (
                    <div className="col-md-12 mt-2">
                      <label className="form-label">Selected Dates</label>
                      <input
                        className="form-control"
                        disabled
                        value={group.frequency.sent_at
                          .map((d) => d.label)
                          .join(", ")}
                      />
                    </div>
                  )}
                </div>

                <div className="mt-3">
                  <div className="row">
                    <div className="col-md-6">
                      <label className="form-label">Start Time</label>
                      <input
                        type="time"
                        name="start"
                        className="form-control"
                        disabled
                        value={group.time_range.start}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">End Time</label>
                      <input
                        className="form-control"
                        disabled
                        type="time"
                        name="end"
                        value={group.time_range.end}
                      />
                    </div>
                  </div>
                </div>

                {row.data.value == "urgent_alarm" && (
                  <div className="mt-4">
                    <div>
                      <h5>Escalation</h5>
                    </div>
                    {group.escalations.map((escalation, escalationIndex) => (
                      <div
                        className="row align-items-center"
                        key={escalationIndex}
                      >
                        <div className="col-md-12">
                          <hr />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Team</label>
                          <input
                            className="form-control"
                            value={
                              teams.find(
                                (team) => team.value == escalation.team_id
                              )?.name
                            }
                            disabled
                          />
                        </div>
                        <div className="col-md-5">
                          <label className="form-label">
                            Escalate after (hours)
                          </label>
                          <input
                            disabled
                            type="number"
                            name="escalation_time"
                            className="form-control"
                            value={escalation.escalation_time}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </CardBody>
            </Card>
          ))}

        {groups.configurations.length == 0 && (
          <div className="p-10 mt-4">
            <h5>No Notification Group Found</h5>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      <LoadingIndicator open={isLoading} />
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Configuration</a>
            </li>
            <li className="breadcrumb-item active">Notification Hierarchy</li>
          </ol>
          <h1 className="page-header mb-0">Notification Hierarchy</h1>
        </div>
      </div>
      <div className="row gx-4">
        <div className="col-lg-12 ">
          <div className="row justify-content-end">
            <div className="col-sm-3 mb-2 mb-sm-0"></div>
          </div>
          <Card className="mb-4 mt-2">
            <CardHeader>List Hierarchy Group</CardHeader>
            <CardBody>
              <DataTable
                highlightOnHover
                expandableRows
                expandableRowsComponent={ExpandedComponent}
                theme="dark"
                columns={columns}
                data={notificationType}
              />
            </CardBody>
          </Card>
        </div>
      </div>

      <ConfirmationDlg
        open={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSelectedNotification(null);
        }}
        loading={isLoading}
        onSubmit={handleSubmit}
        btnSubmitText="Save"
        title={selectedNotification?.name}
        btnCancelText="Cancel"
        size="lg"
      >
        {notificationGroup.map((group, index) => (
          <Card key={index} className="mb-3">
            <CardHeader className="d-flex">
              <h5>Notification Group {index + 1}</h5>
              <button
                className="btn btn-sm btn-outline-danger"
                style={{ marginLeft: "auto" }}
                onClick={() => handleDeleteGroup(index)}
              >
                <i className="fa fa-trash"></i>
              </button>
            </CardHeader>
            <CardBody>
              <div className="row my-2">
                <div className="col-md-3">
                  <Form.Check
                    style={{ textTransform: "capitalize" }}
                    type={"checkbox"}
                    label={"Email"}
                    checked={group.email}
                    onChange={(e) => handleChangePlatform(e, index, "email")}
                  />
                </div>

                <div className="col-md-3">
                  <Form.Check
                    style={{ textTransform: "capitalize" }}
                    type={"checkbox"}
                    label={"WhatsApp"}
                    checked={group.whatsapp}
                    onChange={(e) => handleChangePlatform(e, index, "whatsapp")}
                  />
                </div>
              </div>

              <hr />

              <div className="mt-2">
                <NormalSelect
                  label={"Group"}
                  className="form-select"
                  onchange={(e) => handleChangeTeam(e, index)}
                  valueKey={"value"}
                  list={teams}
                  value={group.team_id}
                />
              </div>

              <div className="row align-items-center">
                <div className="col-md-5">
                  <NormalInput
                    label={"Total Notification per day"}
                    type="number"
                    name="total"
                    min={1}
                    value={group.frequency.total}
                    onchange={(e) => handleChangeFrequency(e, index)}
                  />
                </div>

                <div className="col-md-3">
                  <NormalSelect
                    value={group.frequency.type}
                    label={"Type"}
                    name="type"
                    valueKey={"value"}
                    onchange={(e) => handleChangeFrequency(e, index)}
                    list={[
                      {
                        name: "Day",
                        value: "day",
                      },
                      {
                        name: "Week",
                        value: "week",
                      },
                      {
                        name: "Month",
                        value: "month",
                      },
                    ]}
                  />
                </div>

                {group.frequency.type == "week" && (
                  <div className="col-md-12">
                    <Select
                      isMulti
                      placeholder="Select Day"
                      styles={{
                        ...colourStyles,
                        menu: (styles) => ({
                          ...styles,
                          zIndex: 9999,
                          position: "absolute",
                          color: "grey",
                        }),
                        menuPortal: (styles) => ({
                          ...styles,
                          zIndex: 9999,
                        }),
                      }}
                      options={[
                        {
                          label: "Monday",
                          value: 1,
                        },
                        {
                          label: "Tuesday",
                          value: 2,
                        },
                        {
                          label: "Wednesday",
                          value: 3,
                        },
                        {
                          label: "Thursday",
                          value: 4,
                        },
                        {
                          label: "Friday",
                          value: 5,
                        },
                        {
                          label: "Saturday",
                          value: 6,
                        },
                        {
                          label: "Sunday",
                          value: 7,
                        },
                      ]}
                      value={group.frequency.sent_at}
                      onChange={(e) => {
                        handleChangeSentAt(e, index);
                      }}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>
                )}

                {group.frequency.type == "month" && (
                  <div className="col-md-12">
                    <Select
                      isMulti
                      placeholder="Select Date"
                      styles={{
                        ...colourStyles,
                        menu: (styles) => ({
                          ...styles,
                          zIndex: 9999,
                          position: "absolute",
                          color: "grey",
                        }),
                        menuPortal: (styles) => ({
                          ...styles,
                          zIndex: 9999,
                        }),
                      }}
                      options={[...Array(30)].map((_, i) => ({
                        label: i + 1,
                        value: i + 1,
                      }))}
                      value={group.frequency.sent_at}
                      onChange={(e) => {
                        handleChangeSentAt(e, index);
                      }}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                    />
                  </div>
                )}
              </div>

              <div className="mt-3">
                <div className="row">
                  <div className="col-md-6">
                    <NormalInput
                      label={"Start Time"}
                      type="time"
                      name="start"
                      value={group.time_range.start}
                      onchange={(e) => handleChangeTimeRange(e, index)}
                    />
                  </div>
                  <div className="col-md-6">
                    <NormalInput
                      label={"End Time"}
                      type="time"
                      name="end"
                      value={group.time_range.end}
                      onchange={(e) => handleChangeTimeRange(e, index)}
                    />
                  </div>
                </div>
              </div>

              {selectedNotification?.value == "urgent_alarm" && (
                <div className="mt-3">
                  <div>
                    <h5>Escalation</h5>
                  </div>
                  {group.escalations.map((escalation, escalationIndex) => (
                    <div
                      className="row align-items-center"
                      key={escalationIndex}
                    >
                      <div className="col-md-12">
                        <hr />
                      </div>
                      <div className="col-md-6">
                        <NormalSelect
                          label={"Team"}
                          value={escalation.team_id}
                          onchange={(e) =>
                            handleChangeEscalationTeam(
                              e,
                              index,
                              escalationIndex
                            )
                          }
                          valueKey={"value"}
                          list={teams}
                        />
                      </div>
                      <div className="col-md-5">
                        <NormalInput
                          label={"Escalate after (hours)"}
                          type="number"
                          name="escalation_time"
                          value={escalation.escalation_time}
                          onchange={(e) =>
                            handleChangeEscalation(e, index, escalationIndex)
                          }
                        />
                      </div>
                      <div className="col-md-1">
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() =>
                            handleDeleteEscalation(index, escalationIndex)
                          }
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  ))}

                  <button
                    className="btn btn-sm btn-outline-theme"
                    onClick={() => handleAddMoreEscalation(index)}
                  >
                    Add More Escalation
                  </button>
                </div>
              )}
            </CardBody>
          </Card>
        ))}

        <button
          className="btn btn-sm btn-outline-theme"
          onClick={handleAddMoreGroup}
        >
          Add More Group
        </button>
      </ConfirmationDlg>
    </div>
  );
}
export default NotificationHierarchyConfiguration;
